const removeLeadingZeros = (str) => {
  if (str == '' || str == null) return null
  let parts = str.split('/').map(Number)
  return parts.join('/')
}

export {removeLeadingZeros}
